<template>
	<div class="extra">
		<tabs>
			<tab title="Контакты">
				<i-form :scheme="contactsScheme"/>
			</tab>
			<tab title="Соц сети">
				<i-form :scheme="socialScheme"/>
			</tab>
			<tab title="Страницы">
				
			</tab>
		</tabs>
	</div>
</template>

<script>
export default {

  name: 'extra',

  data () {
    return {
    	"socialScheme": {
	      "facebook": {
	        "type": "string",
	        "label": "Facebook"
	      },
	      "twitter": {
	        "type": "string",
	        "label": "Twitter"
	      },
	      "youtube": {
	        "type": "string",
	        "label": "Youtube"
	      },
	      "instagram": {
	        "type": "string",
	        "label": "Instagram"
	      }
	    },
    	"contactsScheme": {
	      "phone": {
	        "type": "string",
	        "label": "Телефон"
	      },
	      "address": {
	        "type": "string",
	        "label": "Адрес"
	      }
	    }
    }
  }
}
</script>

<style lang="css" scoped>
</style>